export default __webpack_public_path__ + "static/media/VIPP.e756fab9.png";